import { render } from "./ValueList.vue?vue&type=template&id=d04aeff8"
import script from "./ValueList.vue?vue&type=script&lang=js"
export * from "./ValueList.vue?vue&type=script&lang=js"

import "./ValueList.vue?vue&type=style&index=0&id=d04aeff8&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__